import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page not found · Pray With Me';
    return () => { document.title = 'Pray With Me'; };
  }, []);
  return <main className="not-found" aria-labelledby="lost-title">
    <span className="lost-label">404 · PAGE NOT FOUND</span>
    <div className="lost-scene" aria-hidden="true"><span className="lost-number">4</span><span className="lost-sheep">🐑</span><span className="lost-number">4</span></div>
    <h1 id="lost-title">This page has wandered<br />from the flock.</h1>
    <p className="lost-description">We checked the pasture. Twice.<br />This link may have moved, or never existed.</p>
    <Link className="black-button lost-home" to="/">Back to the flock <span aria-hidden="true">→</span></Link>
    <div className="lost-scripture"><span aria-hidden="true">🤍</span><p>A little reminder: the Shepherd goes looking for the one.<small>Inspired by Luke 15:4–6</small></p></div>
  </main>;
}
